import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { ToastMessage } from '@bibliocommons/shared-messages';
import { messagingShape } from '@bibliocommons/bc-prop-types';
import MessagingActions from '../../../actions/MessagingActions';
import { getGlobalMessaging } from '../../../selectors/MessagingSelector';

function GlobalMessagingContainer({ messaging, messagingActions }) {
  const renderMessaging = () => {
    if (messaging && messaging.get('message')) {
      const props = {
        message: messaging.get('message'),
        fieldErrors: messaging.get('fieldErrors'),
        duration: messaging.get('duration'),
        failureDuration: messaging.get('failureDuration'),
        values: messaging.get('values'),
        useFormattedMessage: messaging.get('useFormattedMessage'),
        clearMessages: () => messagingActions.clearGlobalMessage()
      };

      return (<ToastMessage {...props} />);
    }

    return null;
  };

  return (
    <ReactCSSTransitionGroup
      component="div"
      transitionName="slide-up"
      transitionEnterTimeout={250}
      transitionLeaveTimeout={100}>
      {renderMessaging()}
    </ReactCSSTransitionGroup>
  );
}

GlobalMessagingContainer.propTypes = {
  messaging: messagingShape,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state) => ({
  messaging: getGlobalMessaging(state)
});

const mapDispatchToProps = dispatch => ({
  messagingActions: bindActionCreators(MessagingActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalMessagingContainer);



// WEBPACK FOOTER //
// ./app/containers/shared/Messaging/GlobalMessagingContainer.jsx